/*
  assets/pickup-checkout.js
  1) Disables the Checkout button until consent is ticked + location chosen.
  2) Saves attributes[pickup_consent] / attributes[pickup_location] to the cart via AJAX.
  3) Optional: intercepts Checkout, creates a Storefront API cart with the pickup
     location preselected, and redirects to its checkoutUrl. Falls back to the
     normal form submit on any error.

  CONFIGURE the block below.
*/
(function () {
  'use strict';

  // ---------- CONFIG ----------
  var ENABLE_STOREFRONT_PREFILL = true;
  var SHOP_DOMAIN = 'nkdxqe-ue.myshopify.com';
  var STOREFRONT_TOKEN = '4675095127adafff0ee584eb34a87a10';
  var API_VERSION = '2025-01';
  var COUNTRY_CODE = 'HR';
  var CLEAR_CART_NOTICE_AFTER_MS = 10 * 60 * 1000; // 10 min
  // ----------------------------

  console.log('[pickup] script loaded v3, prefill=' + ENABLE_STOREFRONT_PREFILL);

  var block = document.getElementById('pickup-consent-block');
  function findCheckoutBtn() {
    return document.querySelector('form[action*="/cart"] [name="checkout"], [name="checkout"], #checkout');
  }
  var checkoutBtn = findCheckoutBtn();   // may be null now; Clarity renders the cart later

  // ---- Post-order notice (runs on every page) ----
  maybeShowClearCartNotice();

  var ONBOARDING_URL = '/pages/preuzimanje';
  var checkbox = document.getElementById('pickup-consent-checkbox');
  var consentAttr = document.getElementById('pickup-consent-attr');
  var select = document.getElementById('pickup-location');
  var hint = document.getElementById('pickup-consent-hint');
  var hasConsent = block ? block.getAttribute('data-has-consent') === 'true' : true;

  // Attach our inputs to the cart form even if the snippet sits outside it
  var cartForm = null;
  function attachToCartForm() {
    var btn = checkoutBtn || (checkoutBtn = findCheckoutBtn());
    if (!btn) return null;
    cartForm = btn.form || btn.closest('form');
    if (cartForm) {
      if (!cartForm.id) cartForm.id = 'cart';
      [select, consentAttr].forEach(function (el) { if (el && !el.closest('form')) el.setAttribute('form', cartForm.id); });
    }
    return cartForm;
  }
  attachToCartForm();
  if (!cartForm) {
    // wait for Clarity to render the cart summary
    new MutationObserver(function (m, obs) { if (attachToCartForm()) { obs.disconnect(); if (block) refreshButton(); } })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  // Customer already consented and checkbox hidden -> treat as ticked
  var consentTicked = function () {
    if (!block) return true;               // no cart block: onboarding page handles consent
    if (!checkbox) return hasConsent;
    return checkbox.checked;
  };

  function isoNow() { return new Date().toISOString(); }

  function syncConsentValue() {
    if (!consentAttr) return;
    if (consentTicked()) {
      if (!consentAttr.value) {
        consentAttr.value = (hasConsent ? 'reconfirmed ' : '') + isoNow();
      }
    } else {
      consentAttr.value = '';
    }
  }

  function valid() {
    if (!block) return true;
    return consentTicked() && select && select.value;
  }

  function refreshButton() {
    syncConsentValue();
    var ok = valid();
    var btn = checkoutBtn || (checkoutBtn = findCheckoutBtn());
    if (btn) { btn.disabled = !ok; btn.setAttribute('aria-disabled', String(!ok)); }
    if (hint) hint.hidden = ok;
  }

  var saveTimer;
  function saveAttributes() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var attrs = { pickup_location: select ? select.value : '', pickup_consent: consentAttr ? consentAttr.value : '' };
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () { /* form submit still carries attributes */ });
    }, 250);
  }

  if (block) {
    if (checkbox) checkbox.addEventListener('change', function () { refreshButton(); saveAttributes(); });
    if (select) select.addEventListener('change', function () { refreshButton(); saveAttributes(); });
    refreshButton();
    saveAttributes();
  }

  // ---- Step 5: Storefront API prefill ----
  if (!ENABLE_STOREFRONT_PREFILL) return;

  var bypass = false;

  function isCheckoutTrigger(el) {
    return el && el.matches && el.matches('[name="checkout"], #checkout, .cart__checkout-button');
  }

  function interceptCheckout(e, triggerBtn) {
    if (bypass) return;                          // second pass = native submit fallback
    if (!valid()) { e.preventDefault(); refreshButton(); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    console.log('[pickup] intercepting checkout, creating Storefront cart…');
    if (triggerBtn) triggerBtn.disabled = true;
    var nativeForm = (triggerBtn && (triggerBtn.form || triggerBtn.closest('form'))) || cartForm || attachToCartForm();
    createStorefrontCartAndRedirect().catch(function (err) {
      console.warn('[pickup] Storefront prefill failed, falling back:', err);
      bypass = true;
      if (triggerBtn) triggerBtn.disabled = false;
      if (nativeForm && nativeForm.requestSubmit) nativeForm.requestSubmit(triggerBtn || undefined);
      else if (nativeForm) nativeForm.submit();
      else location.href = '/checkout';
    });
  }

  // Delegated + capture phase: survives cart re-renders and runs before theme handlers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[name="checkout"], #checkout, .cart__checkout-button') : null;
    if (btn) interceptCheckout(e, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart') === -1) return;
    var submitter = e.submitter;
    if (isCheckoutTrigger(submitter) || (!submitter && f.querySelector('[name="checkout"]'))) {
      interceptCheckout(e, submitter || f.querySelector('[name="checkout"]'));
    }
  }, true);

  function createStorefrontCartAndRedirect(linesOverride) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!linesOverride && (!cart.items || !cart.items.length)) throw new Error('empty cart');

        // Resolve the location: dropdown > cart attribute > customer metafield > localStorage
        var lsLoc = '', lsConsent = '';
        try { lsLoc = localStorage.getItem('pickupLocation') || ''; } catch (_) {}
        try { lsConsent = localStorage.getItem('pickupConsentAt') || ''; } catch (_) {}

        var locationGid = String(
              (select && select.value) ||
              (cart.attributes && cart.attributes.pickup_location) ||
              window.__pickupDefaultLocation ||
              lsLoc || ''
            ).replace('gid://shopify/Location/', '');   // Shopify wants the bare numeric ID

        var consentAt = (cart.attributes && cart.attributes.pickup_consent) ||
                        window.__pickupConsentAt ||
                        (window.__pickupHasConsentTag ? 'tag' : '') ||
                        lsConsent || '';

        if (!locationGid || !consentAt) {
          window.location.href = ONBOARDING_URL + '?return_to=' + encodeURIComponent(location.pathname);
          return new Promise(function () {}); // stop here; page is navigating
        }

        var cartAttrs = Object.keys(cart.attributes || {}).map(function (k) {
          return { key: k, value: String(cart.attributes[k]) };
        });

        // Make sure the resolved values travel onto the order, even if the cart had none
        var seen = {};
        cartAttrs.forEach(function (a) { seen[a.key] = true; });
        if (!seen.pickup_location) cartAttrs.push({ key: 'pickup_location', value: locationGid });
        if (!seen.pickup_consent)  cartAttrs.push({ key: 'pickup_consent',  value: consentAt });

        var lines = linesOverride || cart.items.map(function (it) {
          var attrs = Object.keys(it.properties || {})
            .filter(function (k) { return k.charAt(0) !== '_'; })
            .map(function (k) { return { key: k, value: String(it.properties[k]) }; });
          return {
            merchandiseId: 'gid://shopify/ProductVariant/' + it.variant_id,
            quantity: it.quantity,
            attributes: attrs
          };
        });


        var email = (window.__pickupCustomerEmail || '').trim();

        var input = {
          lines: lines,
          attributes: cartAttrs,
          note: cart.note || null,
          // discountCodes: ['CODE'],   // <- add if your theme applies codes in the cart
          buyerIdentity: {
            countryCode: COUNTRY_CODE,
            preferences: {
              delivery: {
                deliveryMethod: ['PICK_UP'],
                pickupHandle: [locationGid]
              }
            }
          }
        };
        if (email) input.buyerIdentity.email = email;

        var query =
          'mutation CreateCart($input: CartInput!) {' +
          '  cartCreate(input: $input) {' +
          '    cart { id checkoutUrl }' +
          '    userErrors { field message }' +
          '  }' +
          '}';

        return fetch('https://' + SHOP_DOMAIN + '/api/' + API_VERSION + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
          },
          body: JSON.stringify({ query: query, variables: { input: input } })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var data = res && res.data && res.data.cartCreate;
        if (!data || !data.cart || !data.cart.checkoutUrl) {
          throw new Error(JSON.stringify((data && data.userErrors) || res.errors || res));
        }
        try { sessionStorage.setItem('pickupCheckoutStartedAt', String(Date.now())); } catch (_) {}
        window.location.href = data.cart.checkoutUrl;
      });
  }

  // ---- Custom "Kupi odmah" (replaces Shopify's dynamic checkout button) ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pickup-buy-now]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var idEl = form && form.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    var lines = [{ merchandiseId: 'gid://shopify/ProductVariant/' + idEl.value, quantity: qty, attributes: [] }];

    btn.disabled = true;
    createStorefrontCartAndRedirect(lines).catch(function (err) {
      console.warn('[pickup] Buy-now prefill failed, falling back to native checkout:', err);
      // Fallback: add to cart and go to native checkout
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idEl.value, quantity: qty }) })
        .then(function () { location.href = '/checkout'; })
        .catch(function () { btn.disabled = false; });
    });
  });

  // ---- Helper: notice to clear the theme cart after a Storefront checkout ----
  function maybeShowClearCartNotice() {
    var started;
    try { started = Number(sessionStorage.getItem('pickupCheckoutStartedAt')); } catch (_) { return; }
    if (!started || Date.now() - started < CLEAR_CART_NOTICE_AFTER_MS) return;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) { sessionStorage.removeItem('pickupCheckoutStartedAt'); return; }
        var bar = document.createElement('div');
        bar.style.cssText = 'position:fixed;bottom:0;left:0;right:0;z-index:9999;padding:.9rem 1rem;background:#111;color:#fff;font:14px system-ui;display:flex;gap:1rem;justify-content:center;align-items:center;';
        bar.innerHTML = 'Jeste li dovršili narudžbu? ' +
          '<button id="pickup-clear-cart" style="padding:.4rem .8rem;border:0;border-radius:4px;background:#fff;color:#111;cursor:pointer">Isprazni košaricu</button>' +
          '<button id="pickup-keep-cart" style="padding:.4rem .8rem;border:1px solid #fff;border-radius:4px;background:transparent;color:#fff;cursor:pointer">Zadrži</button>';
        document.body.appendChild(bar);
        document.getElementById('pickup-clear-cart').onclick = function () {
          fetch('/cart/clear.js', { method: 'POST' }).then(function () {
            sessionStorage.removeItem('pickupCheckoutStartedAt'); location.reload();
          });
        };
        document.getElementById('pickup-keep-cart').onclick = function () {
          sessionStorage.removeItem('pickupCheckoutStartedAt'); bar.remove();
        };
      })
      .catch(function () {});
  }
})();
